import standardApiRequestAction from 'my-core/standardApiRequestAction';

export function fetchTokenPurchases(body, fetchKey) {
  return standardApiRequestAction({
    path: '/api/v1/token_purchases',
    requestKey: fetchKey,
    body,
  });
}

export function createOCActivityTokenPurchase(ocaId) {
  return standardApiRequestAction({
    path: '/api/v1/token_purchases/purchase_oc_activity',
    method: 'post',
    body: { oc_activity_id: ocaId },
  });
}

export function createOCPracticeQuestionTokenPurchase(ocId, qqId, ocSectionId) {
  return standardApiRequestAction({
    path: '/api/v1/token_purchases/purchase_practice_question',
    method: 'post',
    body: { online_course_id: ocId, quiz_question_id: qqId, online_course_section_id: ocSectionId },
  });
}
